import RewardsEarnPointsSchema from "@apps/rewards/schemas/RewardsEarnPointsSchema";
import type ApiClientInterface from "@lib/ApiClient/ApiClientInterface";
import { Observable, map } from "rxjs";
import { create } from "superstruct";
import { inject, singleton } from "tsyringe";

import { RewardsEarnPointsEntity } from "../entities/entities";
import { rewardsAuthApiClientToken } from "../tokens";

@singleton()
class RewardsEarnPointsApiService {
    constructor(
        @inject(rewardsAuthApiClientToken)
        private readonly apiClient: ApiClientInterface
    ) {}

    getAmountForProduct(
        productId: number
    ): Observable<RewardsEarnPointsEntity> {
        return this.apiClient
            .get({
                url: "/points/getAmountForProduct",
                responseType: "json",
                queryParams: { productId },
            })
            .pipe(
                map((response) =>
                    create(response.body, RewardsEarnPointsSchema)
                )
            );
    }
}

export default RewardsEarnPointsApiService;
